module.exports = __webpack_public_path__ + "static/lachlan-dempsey-O14abKtZ5iY-unsplash-01ae17adab6f2a7fc8cd44365d25952a.png";